// extracted by css-extract-rspack-plugin
export default {"app":"app-zjKxc8","container-layout":"container-layout-WtLYlj","containerLayout":"container-layout-WtLYlj","config":"config-QwlRUm","logo":"logo-fSjqn0","loading":"loading-C62X0m"};